import { MimshakData } from "./mimshakData";
import { Mimshak } from "./mislaka_xml_models";

export enum UploadedFileType {
  REGULAR = "REGULAR",
  PREADVICE = "PREADVICE",
  FINANCIAL_POLICIES_COBOL = "FINANCIAL_POLICIES_COBOL",
  AYLON_PRODUCTION_FILES = "AYLON_PRODUCTION_FILES",
}
export interface FileProcessingResultDTO {
  filename: string;
  status: "success" | "failure" | "ignored" | "awaiting_user_confirmation";
  mimshaks?: Mimshak[] | null;
  error?: string;

  proposed_report_date?: string;
  proposed_handler_code?: string;
  required_fields?: string[];
  file_type?: UploadedFileType;
  // שדה חדש לשמירת פוליסות שנכשלו (policy_number, error_message)
  failed_policies?: [string, string][];
}
export interface PreviewSaveSummaryDTO {
    success_contacts_count: number;
    failed_contacts_count: number;
    mimshak_data_sample?: MimshakData;
    successful_files_count: number
    failed_files_count: number
    ignored_files_count: number
    // ✅ שדה חדש לתוצאות הקבצים עצמם
    preview_results?: FileProcessingResultDTO[];
}

export interface ConfirmedZipInputDTO {
  zip_filename: string;
  confirmed_report_date: Date;
  handler_code: string;
}